import { Subject } from 'rxjs'

/**
 * Emitido quando a API rejeita uma requisição com 401 e não há token novo no cookie para recuperar a
 * sessão. Quem trata é o Authenticator (dono da UX de sessão) — a camada de HTTP não abre modal.
 */
export const SessionExpired = new Subject<void>()
